<template>
  <div>
    <div v-for="(range, index) in dateRanges" :key="index" class="flex flex-wrap gap-4 mb-6">
      <div class="flex-1 min-w-[200px]">
        <label>Start Date</label>

        <input
          type="date"
          class="form-input w-full rounded-md shadow-sm border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
          v-model="range.start_date"
          @change="updateDateRanges"
          :name="`${name}[${index}][start_date]`"
        />
      </div>
      <div class="flex-1 min-w-[200px]">
        <label>End Date</label>

        <input
          type="date"
          class="form-input w-full rounded-md shadow-sm border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
          v-model="range.end_date"
          @change="updateDateRanges"
          :name="`${name}[${index}][end_date]`"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NdisDateRanges",
  props: {
    name: {
      type: String,
      default: 'ndis_funding_periods'
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dateRanges: []
    };
  },
  mounted() {
    if (this.modelValue && this.modelValue.length) {
      this.dateRanges = this.modelValue.map(range => {
        return {
          start_date: range.start_date || '',
          end_date: range.end_date || ''
        };
      });
    }

    // Ensure we always have exactly 4 date ranges
    while (this.dateRanges.length < 4) {
      this.dateRanges.push({
        start_date: '',
        end_date: ''
      });
    }

    // Trim to 4 date ranges if there are more
    if (this.dateRanges.length > 4) {
      this.dateRanges = this.dateRanges.slice(0, 4);
    }

    this.updateDateRanges();
  },
  methods: {
    updateDateRanges() {
      this.$emit('update:modelValue', this.dateRanges);
    }
  }
};
</script>
